import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";

@Component({
	selector: "sunset-digi-banner",
	standalone: true,
	imports: [CoreModule],
	templateUrl: "./sunset-digi-banner.component.html",
	styleUrl: "./sunset-digi-banner.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SunsetDigiBannerComponent {
	isPortfolioBanner = input<boolean>(false);
	ownedAssets = input<number>(0);

	getMoreInfoLink(): string {
		const langIso = TranslationService.getLanguageIsoCode();
		return `${config.helpcenterUrl}hc/${langIso}/articles/23521681276956`;
	}
}
